(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('questionnaire-admin', {
            parent: 'admin',
            url: '/questionnaire-admin',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire-edit/questionnaires-admin-list.html',
                    controller: 'QuestionnairesListController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('questionnaireEdit');
                        $translatePartialLoader.addPart('questionnaire');
                        $translatePartialLoader.addPart('question');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('questionnaireType');
                        $translatePartialLoader.addPart('anomalyType');
                        return $translate.refresh();
                    }]
            }
        })
        .state('questionnaire-admin.new', {
            parent: 'questionnaire-admin',
            url: '/new',
            params : {
                companyId: null
            },
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire-edit/questionnaire-edit-dialog.html',
                    controller: 'QuestionnaireEditDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function () {
                    return {
                        title: null,
                        description: null,
                        sections: [],
                        deleted: false,
                        company: null
                    };
                }
            }
        })
        .state('questionnaire-admin.edit', {
            parent: 'questionnaire-admin',
            url: '/edit/{id}',
            params : {
                companyId: null
            },
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire-edit/questionnaire-edit-dialog.html',
                    controller: 'QuestionnaireEditDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['Questionnaire', '$stateParams', function (Questionnaire, $stateParams) {
                        return Questionnaire.get({id: $stateParams.id}).$promise;
                }]
            }
        })
            .state('questionnaire-admin.copy', {
                parent: 'questionnaire-admin',
                url: '/copy/{id}',
                params : {
                    companyId: null,
                    copyMode: true
                },
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/questionnaire-edit/questionnaire-edit-dialog.html',
                        controller: 'QuestionnaireEditDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['QuestionnaireCompany', '$stateParams', function (QuestionnaireCompany, $stateParams) {
                        return QuestionnaireCompany.CopyToEditForAdmin.copytoeditforadmin({id: $stateParams.id}).$promise;
                    }]
                }
            })
        .state('questionnaire-admin.delete', {
            parent: 'questionnaire-admin',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/questionnaire-edit/questionnaire-delete-dialog.html',
                        controller: 'QuestionnaireDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Questionnaire', function (Questionnaire) {
                                    return Questionnaire.get({id: $stateParams.id}).$promise;
                                }]
                        }
                    }).result.then(function () {
                        $state.go('questionnaire-admin', null, {reload: 'questionnaire-admin'});
                    }, function () {
                        $state.go('^');
                    });
                }]
        });
    }
})();
